// extracted by mini-css-extract-plugin
export default {"container":"Page__container___h0DtS","pageContentRight":"Page__pageContentRight___gk5MR","pageContentRightMinSize":"Page__pageContentRightMinSize___RQZul"};